import { useEffect, useState } from 'react';

function nextUrl(urlParams) {
    const params = urlParams.toString();

    return params ? `${window.location.pathname}?${params}` : window.location.pathname;
}

export default function useUrlParam(paramName, consumeParam = false) {
    // ✅ Initialize from URL once (no cascading renders)
    const [value, setValue] = useState(() => {
        const urlParams = new URLSearchParams(window.location.search);
        
        return urlParams.get(paramName) || undefined;
    });

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const v = urlParams.get(paramName) || undefined;

        // ✅ Only update state if value actually changed
        if (v !== value) {
            if (v && consumeParam) {
                urlParams.delete(paramName);
                window.history.replaceState({}, document.title, nextUrl(urlParams));
            }
            setValue(v);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paramName, consumeParam]);

    return value;
}
